// src/services/api/showreelApi.ts
import { createApiService } from './base';
import { ShowreelItem } from '../../types/content';

const showreelService = createApiService<ShowreelItem>('showreel');

export const fetchShowreel = showreelService.getAll;
export const fetchShowreelItem = showreelService.getOne;
export const createShowreelItem = showreelService.create;
export const updateShowreelItem = showreelService.update;
export const deleteShowreelItem = showreelService.delete;
export const updateShowreelOrder = showreelService.updateOrder;
